var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.02 0 0 228.996 0 512c0 282.98 228.994 512 512 512 282.98 0 512-228.993 512-512C1024 229.02 795.006 0 512 0zm0 955.735C267.326 955.735 68.266 756.677 68.266 512S267.326 68.268 512 68.268 955.734 267.327 955.734 512 756.674 955.736 512 955.736zm-.006-536.18c-18.85 0-34.134 15.282-34.134 34.134v287.937c0 18.85 15.282 34.134 34.134 34.134s34.134-15.28 34.134-34.133v-287.94c-.002-18.852-15.284-34.132-34.134-34.132zm.006-171.31c-37.642 0-68.266 30.624-68.266 68.266s30.624 68.267 68.266 68.267 68.266-30.624 68.266-68.266-30.624-68.265-68.266-68.265z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.aeb6f510fc29a76bac3c7824a608c295.svg";
export { ForwardRef as ReactComponent };